<template>
  <div class="container">
    <div class="item" v-for="item in list" :key="item.address_id">
      <div class="box1">
        <div class="info">
          <p>{{ item.name }} {{ item.phone }}</p>
          <p>{{ item.region.province }} {{ item.region.city }} {{ item.region.region }} {{ item.detail }}</p>
        </div>
        <div class="isDefault">
          <span>是否设置为默认地址 </span>
          <van-switch :value="defaultId === item.address_id" size="14px" @click="setDefault(item.address_id)" />
        </div>
      </div>
      <div class="box2">
        <button class="edit" @click="editFn(item.address_id)">编辑</button>
        <button class="del" @click="delFn(item.address_id)">删除</button>
      </div>
    </div>
  </div>
</template>

<script>
import { setDefaultAddressApi } from '@/api/address'

export default {
  name: 'AddressItem',
  props: {
    // 收货地址列表
    list: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    // 默认地址 id
    defaultId () {
      const target = this.list.find(item => item.is_default === 1)
      return target ? target.address_id : -1
    }
  },
  methods: {
    // 设置默认地址
    async setDefault (addressId) {
      await setDefaultAddressApi(addressId)
      this.$store.dispatch('address/getReceivedAddressList')
    },
    // 编辑地址
    editFn (addressId) {
      this.$router.push({
        path: '/editaddress',
        query: { addressId }
      })
    },
    // 删除地址
    delFn (addressId) {
      this.$dialog.confirm({
        title: '温馨提示',
        message: '确定删除该收货地址吗？'
      })
        .then(() => {
          this.$store.dispatch('address/deleteAddress', addressId)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.item {
  padding: 5px 10px;
  border-bottom: 1px solid #000;
  display: flex;
  justify-content: space-between;
  background-color: #fff;

  .box1 {
    .info {
      margin-bottom: 3px;

      p:first-child {
        font-size: 16px;
        font-weight: 700;
      }
    }

    .isDefault {
      display: flex;
      margin-top: 5px;
      justify-content: start;
      align-items: center;

      span {
        font-size: 12px;
        margin-right: 5px;
      }
    }
  }

  .box2 {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .del,
    .edit {
      padding: 0;
      border: none;
      background-color: #1989fa;
      color: #fff;
      width: 50px;
      height: 23px;
      line-height: 23px;
      border-radius: 5px;

      &:active {
        background-color: #06f;
      }
    }

    .edit {
      margin-bottom: 5px;
    }
  }
}
</style>
